export default __webpack_public_path__ + "static/media/bg_21.c140f8d4.png";